import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/screenshots/mazii_logo.png'
import _imports_1 from '../../assets/img/icons/facebook.svg'
import _imports_2 from '../../assets/img/icons/pinterest.svg'
import _imports_3 from '../../assets/img/icons/instagram.svg'
import _imports_4 from '../../assets/img/icons/twitter.svg'


const _hoisted_1 = {
  class: "responsive-navbar offcanvas offcanvas-end border-0",
  "data-bs-backdrop": "static",
  tabindex: "-1",
  id: "navbarOffcanvas"
}
const _hoisted_2 = { class: "offcanvas-header" }
const _hoisted_3 = { class: "offcanvas-body" }
const _hoisted_4 = { class: "responsive-menu mobile-menu" }
const _hoisted_5 = { class: "responsive-menu-items" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo d-inline-block"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            class: "logo-light",
            src: _imports_0,
            alt: "Image"
          }, null, -1),
          _createElementVNode("img", {
            class: "logo-dark",
            src: _imports_0,
            alt: "Image"
          }, null, -1)
        ])),
        _: 1
      }),
      _cache[2] || (_cache[2] = _createElementVNode("button", {
        type: "button",
        class: "close-btn bg-transparent lh-1 p-0",
        "data-bs-dismiss": "offcanvas",
        "aria-label": "Close"
      }, [
        _createElementVNode("i", { class: "ri-close-line" })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _cache[6] || (_cache[6] = _createStaticVNode("<li class=\"responsive-menu-list nav-item\" data-v-b83319c8><a href=\"#hero-area\" class=\"nav-link\" data-v-b83319c8>Home</a></li><li class=\"nav-item\" data-v-b83319c8><a class=\"nav-link\" href=\"#about-area\" data-v-b83319c8>Why Mazii</a></li><li class=\"nav-item\" data-v-b83319c8><a class=\"nav-link\" href=\"#testimonials-area\" data-v-b83319c8>What Couples Say</a></li><li class=\"nav-item\" data-v-b83319c8><a class=\"nav-link\" href=\"#hw-area\" data-v-b83319c8>More special features</a></li>", 4)),
        _createElementVNode("li", {
          class: _normalizeClass([
            'responsive-menu-list mobile-menu-child',
            { active: _ctx.isActivePages },
          ])
        }, [
          _createElementVNode("a", {
            href: "javascript:void(0)",
            class: "dropdown-toggle",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleActivePages && _ctx.toggleActivePages(...args)))
          }, " Pages "),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, { to: "/faq" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("FAQ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, { to: "/terms-conditions" }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Terms & Conditions ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, { to: "/privacy-policy" }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Privacy Policy ")
                ])),
                _: 1
              })
            ])
          ])
        ], 2)
      ]),
      _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"other-option d-md-flex align-items-center\" data-v-b83319c8><ul class=\"social-profile list-style text-md-center\" data-v-b83319c8><li data-v-b83319c8><a href=\"https://www.fb.com\" target=\"_blank\" data-v-b83319c8><img src=\"" + _imports_1 + "\" alt=\"Facebook\" data-v-b83319c8></a></li><li data-v-b83319c8><a href=\"https://www.pinterest.com\" target=\"_blank\" data-v-b83319c8><img src=\"" + _imports_2 + "\" alt=\"Linkedin\" data-v-b83319c8></a></li><li data-v-b83319c8><a href=\"https://www.instagram.com\" target=\"_blank\" data-v-b83319c8><img src=\"" + _imports_3 + "\" alt=\"Instagram\" data-v-b83319c8></a></li><li data-v-b83319c8><a href=\"https://www.twitter.com\" target=\"_blank\" data-v-b83319c8><img src=\"" + _imports_4 + "\" alt=\"Twitter\" data-v-b83319c8></a></li></ul></div>", 1))
    ])
  ]))
}